// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"36d8eabb","186":"fdacc222","440":"a801c8c6","453":"c6e9488e","459":"531fa1db","660":"d83b31b4","693":"23b13796"}[chunkId] + ".chunk.js";
};